export const JOB_PROFILES_SET = 'JOB_PROFILES_SET';
export const JOB_PROFILES_ERROR = 'JOB_PROFILES_ERROR';
export const JOB_PROFILES_IS_LOADING = 'JOB_PROFILES_IS_LOADING';
